import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, withKeys as _withKeys, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute-full-size overlay"
}
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "reply-icon" }
const _hoisted_4 = { class: "flex-fill text-truncate text" }
const _hoisted_5 = { class: "font-weight-bold pb-1" }
const _hoisted_6 = { class: "text-truncate" }
const _hoisted_7 = { class: "close text-right" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex horizontal"
}
const _hoisted_9 = ["value", "placeholder", "readonly"]
const _hoisted_10 = {
  key: 1,
  class: "d-inline-block"
}
const _hoisted_11 = { class: "icon" }
const _hoisted_12 = { class: "icon" }

import {computed, getCurrentInstance, nextTick, onMounted, ref, watch} from 'vue';
import {ChatTabStore} from "~/chat/ts/store/ChatTab";
import SvgIcon from "~/chat/vue/misc/SvgIcon.vue";
import {ConfigStore} from "~/chat/ts/store/Config";
import Delay from "~/ts/library/Delay";
import {OperatorsStore} from "~/chat/ts/store/Operators";
import MessageWrapper from "~/chat/ts/data/chat/MessageWrapper";
import MessageSender from "~/chat/ts/service/messages/MessageSender";
import EmojiSelector from "~/chat/vue/widget/tabs/chat/EmojiSelector.vue";
import ChatPopover from "~/chat/vue/misc/ChatPopover.vue";
import IChatFooter from "~/chat/vue/widget/tabs/chat/IChatFooter";
import IChatUploadFile from "~/chat/vue/widget/form/IChatUploadFile";
import ChatUpload from "~/chat/vue/widget/form/ChatUpload.vue";
import {WidgetStore} from "~/chat/ts/store/Widget";
import ResizableTextarea from "~/chat/vue/forms/ResizableTextarea.vue";
import {IResizableTextarea} from "~/chat/vue/forms/IResizableTextarea";
import {EMOJI_LIST} from "~/chat/vue/widget/tabs/chat/EmojiList";
import {IChatUpload} from "~/chat/vue/widget/form/IChatUpload";
import ChatNodeRequest from "~/chat/ts/service/ChatNodeRequest";
import {__} from "~/ts/library/Translate";
import {VoiceRecorderResult} from "~/ts/library/VoiceRecorder";
import MessageStorage from "~/chat/ts/service/messages/MessageStorage";
import ChatAttachList from "~/chat/vue/widget/tabs/chat/ChatAttachList.vue";
import ChatScrollContainer from "~/chat/vue/misc/ChatScrollContainer.vue";
import {WidgetStickerInterface} from "~/chat/ts/data/ISiteParams";


import {defineAsyncComponent} from "vue";

const __default__ = {
    name: "ChatFooter",
    components: {
        VoiceMessageRecorder: defineAsyncComponent(() => import(/* webpackChunkName: "chat-media" */ '~/chat/vue/widget/tabs/chat/media/VoiceMessageRecorder.vue')),
    }
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {

let lastStartButtonClick: number = 0;

let resizableTextarea = ref<IResizableTextarea>();
let textarea = ref<HTMLTextAreaElement>();
let upload = ref<IChatUpload>();

let showEmoji = ref(false);
let attach = ref<IChatUploadFile[]>([]);

onMounted(() => {
    focusTextarea();
    resize();
});

function focusTextarea() {
    if (!ConfigStore.isMobile.value && isChatTabOpened.value) {
        if (!WidgetStore.inlineMode.value) {
            let input = document.querySelector("input:focus, textarea:focus");
            if (!input && textarea.value) {
                textarea.value.focus();
            }
        }
    }
}

let isChatTabOpened = computed(() => {
    return WidgetStore.isOpened.value && WidgetStore.currentTab.value === WidgetStore.chatTab.value;
});


let text = computed({
    get: () => {
        return ChatTabStore.textareaValue.value;
    }, set: (value: string | null) => {
        ChatTabStore.setTextareaValue(value);
    }
});

let replyToMessage = computed<MessageWrapper>(() => {
    let id = ChatTabStore.replyToMessageId.value;
    if (id) {
        let message = MessageStorage.getMessage(id);
        if (message) {
            return new MessageWrapper(message);
        }
    }
    return null;
});

let offlineButtonText = computed(() => {
    let buttonText = ConfigStore.siteParams.value.params.leadGen.pmForm.buttonUnderChatHistory;
    return buttonText ? buttonText : __("ASK_QUESTION");
});


function onEmojiSelect(value: string) {
    if (text.value) {
        text.value += ` ${value}`;
    } else {
        text.value = value;
        sendMessage();
    }
    showEmoji.value = false;
    textarea.value.focus();
}

function onStickerSelect(sticker: WidgetStickerInterface) {
    let sender = new MessageSender({
        other: {
            sticker: {
                id: sticker.id,
                url: sticker.url
            }
        }
    });

    showEmoji.value = false;
    textarea.value.focus();

    sender.send();
}

function onRootClick() {
    if (isOfflineFormButtonDisplayed.value) {
        ChatTabStore.toggleOfflineForm(true);
    } else if (isStartButtonDisplayed.value) {
        if (lastStartButtonClick < Date.now() - 10000) {
            lastStartButtonClick = Date.now();
            let startText = ConfigStore.siteParams.value.params.online.startButtonMessageText;
            text.value = startText ? startText : "/start";
            sendMessage();
        }
    }
}

let isFooterDisplayed = computed(() => {
    return isTextareaDisplayed.value || isButtonDisplayed.value;
});

let isButtonDisplayed = computed(() => {
    return isOfflineFormButtonDisplayed.value || isStartButtonDisplayed.value;
});

let isTextareaDisplayed = computed(() => {
    return !isButtonDisplayed.value;
});

let isStartButtonDisplayed = computed(() => {
    return !isOfflineFormButtonDisplayed.value && ConfigStore.siteParams.value.params.online.showStartButton && !ChatTabStore.isDialogRunning.value && !ChatTabStore.isMessageSendBlocked.value;
    /*
    PUSH_TO_DEBUG_CONSOLE(JSON.stringify({
        result,
        "!isOfflineFormButtonDisplayed": !isOfflineFormButtonDisplayed.value,
        showStartButton: ConfigStore.siteParams.value.params.online.showStartButton,
        '!isDialogRunning': !ChatTabStore.isDialogRunning.value,
        '!isMessageSendBlocked': !ChatTabStore.isMessageSendBlocked.value
    }));*/
    //return result;
});

let startButtonText = computed(() => {
    let text = ConfigStore.siteParams.value.params.online.startButtonText;
    if (!text) {
        text = __("START");
    }
    return text;
});

let isOfflineFormButtonDisplayed = computed(() => {
    return ChatTabStore.isOfflineFormButtonDisplayed.value;
});

let isMessageSendBlocked = computed(() => {
    let result = isTextareaDisplayed.value && ChatTabStore.isMessageSendBlocked.value;
    if (!result) {
        let lastMessage = MessageStorage.lastMessage;
        if (lastMessage) {
            let lastMessageWrapper = new MessageWrapper(lastMessage);
            result = lastMessageWrapper.isTextInputBlocked;
        }
    }
    return result;
});

let widgetPaddingLeft = computed(() => {
    return ConfigStore.widgetPaddingLeft.value;
});

let design = computed(() => {
    return ConfigStore.design.value.dialog;
});

let textareaDesign = computed(() => {
    return design.value.textarea;
});

let textareaPaddingLeft = computed(() => {
    return `${textareaDesign.value.padding.leftRight + widgetPaddingLeft.value}em`;
});

let sendButtonColor = computed(() => {
    let result = textareaDesign.value.sendMessageButtonColor;
    if (!result) {
        result = ConfigStore.design.value.linkColor;
    }
    return result;
});

function onPaste(e: ClipboardEvent) {
    if (e.clipboardData) {
        let items = e.clipboardData.files;
        let files: File[] = [];
        for (let index = 0; index < items.length; index++) {
            files.push(items.item(index));
        }
        if (files.length && upload.value) {
            upload.value.newFilesList(files);
        }
    }
}

function sendMessageOnEnter(e: KeyboardEvent) {
    if (!e.shiftKey) {
        e.preventDefault();
        sendMessage();
    }
}

let isUploadAvailable = computed(() => {
    return ConfigStore.siteParams.value.params.siteChatOptions.upload;
});

let hideUploadButton = computed(() => {
    return showSendButton.value && !textareaDesign.value.alwaysShowSendButton;
});

let showSendButton = computed(() => {
    return textareaDesign.value.alwaysShowSendButton || isReadyToSend.value;
});

let isAudioAvailable = computed(() => {
    let media = ConfigStore.siteParams.value.params.media;
    return media && media.voiceMessages.enabled && window.location.protocol == "https:";
});

let isReadyToSend = computed(() => {
    return (text.value?.length) || attach.value.length;
});

function resize() {
    if (resizableTextarea.value) {
        nextTick(() => resizableTextarea.value.setStyle());
    }
}

let instance = getCurrentInstance().proxy;

async function sendMessage() {
    textarea.value?.focus();
    showEmoji.value = false;
    if (!isMessageSendBlocked.value && isReadyToSend.value) {
        let message = new MessageWrapper();
        let originalText = text.value;

        if (typeof originalText == "string" && originalText.length > 0) {
            message.text = originalText.replace(/:([a-z_]*):/gm, (full: string, emojiText: string) => {
                return EMOJI_LIST[emojiText] ? EMOJI_LIST[emojiText] : full;
            });
        }
        let attachments = attach.value;

        let replyToMessageId = ChatTabStore.replyToMessageId.value;
        if (replyToMessageId) {
            let replyMessage = MessageStorage.getMessage(replyToMessageId);
            message.setReplyToMessage(replyMessage);
            ChatTabStore.SET_REPLY_TO_MESSAGE_ID(null);
        }

        for (let attach of attachments) {
            message.addAttachment({
                fileName: attach.filename,
                url: attach.url,
                size: attach.size,
                type: undefined
            });
        }

        let sender = new MessageSender(message.rawMessage);


        let result = await sender.send(() => {
            text.value = null;
            resize();
            attach.value = [];
        });

        if (!result.isSuccess()) {
            WidgetStore.showModalMessage({text: result.getDescr(), vue: instance});
            attach.value = attachments;
            text.value = originalText;
            ChatTabStore.SET_REPLY_TO_MESSAGE_ID(replyToMessageId);
            resize();
        }
    }

}


let prevSendedTyping = ref<string>();

async function onMessageInput(event: InputEvent) {
    text.value = (event.target as HTMLTextAreaElement).value;
    let siteParams = ConfigStore.siteParams.value;
    if (!siteParams.free) {
        try {
            await Delay.make(1000, "typePublish", false);
        } catch (e) {
            return;
        }

        var value = text.value;
        if (value && value.length && value != prevSendedTyping.value) {
            let canSendTypingNotification = false;

            prevSendedTyping.value = value;
            let operator = OperatorsStore.selected.value.operator;

            if (operator) {
                canSendTypingNotification = !MessageSender.isNeedToAskForOperator;

                if (OperatorsStore.balanceType.value.canSendTypingNotification) {
                    canSendTypingNotification = true;
                }
                if (!siteParams.params.operators.typingNotifications) {
                    canSendTypingNotification = false;
                }
            }

            (async () => {
                try {
                    let body: CometWidget.CometClientTypingBodyOpenApiModel = {
                        ...ChatNodeRequest.getClientCredentials(),
                        text: value,
                        operatorUid: operator?.uid,
                        operatorLogin: null,
                        isBalancerEnabled: !canSendTypingNotification
                    };
                    await (new ChatNodeRequest("/clientTyping"))
                        .setBody(body)
                        .send();
                } catch (e) {

                }
            })();

        }
    }
}

let isEmojiUsed = computed(() => {
    return !!ConfigStore.siteParams.value.params.siteChatOptions.emoji && !ConfigStore.isMobile.value;
});

function attachFiles(files: IChatUploadFile[]) {
    attach.value.push(...files);
}

function onVoiceMessage(voice: VoiceRecorderResult) {
    let file = new File([voice.blob], `voice.${voice.format.extension}`);
    upload.value.newFilesList([file], 'mp3');
}

function removeReplyTo() {
    ChatTabStore.SET_REPLY_TO_MESSAGE_ID(null);
}

watch(isChatTabOpened, () => focusTextarea());

watch(isMessageSendBlocked, () => {
    if (isMessageSendBlocked.value) {
        textarea.value?.blur();
    }
});

__expose<IChatFooter>({
    attachFiles
});



return (_ctx: any,_cache: any) => {
  const _component_voice_message_recorder = _resolveComponent("voice-message-recorder")!
  const _directive_on_native = _resolveDirective("on-native")!

  return (_unref(isFooterDisplayed))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: onRootClick,
        class: _normalizeClass([
                'chat-textarea-wrapper',
                'd-flex',
                'vertical',
                'relative',
                _unref(isMessageSendBlocked) ? 'blocked' : null
            ])
      }, [
        (_unref(isMessageSendBlocked))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1))
          : _createCommentVNode("", true),
        (_unref(replyToMessage))
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "reply-to",
              style: _normalizeStyle({
                padding: `.5em ${_unref(textareaPaddingLeft)} 0 !important`
            })
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(SvgIcon, {
                    "icon-name": "reply",
                    style: _normalizeStyle({color: `${_unref(sendButtonColor)} !important`})
                  }, null, 8, ["style"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(__)("ANSWER")) + ": ", 1),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(replyToMessage).textForReplyPreview), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createVNode(SvgIcon, {
                    "icon-name": "times",
                    class: "cursor-pointer"
                  }, null, 512), [
                    [_directive_on_native, removeReplyTo, "click"]
                  ])
                ])
              ])
            ], 4))
          : _createCommentVNode("", true),
        _createVNode(ChatAttachList, {
          class: "attach-list blur-on-block",
          style: _normalizeStyle({
                padding: `.5em ${_unref(textareaPaddingLeft)} 0 !important`
            }),
          attachments: _unref(attach),
          "onUpdate:attachments": _cache[0] || (_cache[0] = ($event: any) => (_isRef(attach) ? (attach).value = $event : attach = $event))
        }, null, 8, ["style", "attachments"]),
        _createElementVNode("div", {
          class: "relative",
          style: _normalizeStyle({
                        margin: `${_unref(textareaDesign).padding.topBottom}em 0 !important`
                    })
        }, [
          (_unref(isTextareaDisplayed))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(ResizableTextarea, {
                  ref_key: "resizableTextarea",
                  ref: resizableTextarea
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("textarea", {
                      ref_key: "textarea",
                      ref: textarea,
                      class: _normalizeClass(['textarea', 'blur-on-block', 'typo', 'filler', 'chat-textarea', 'ym-disable-keys']),
                      value: _unref(text),
                      placeholder: `${_unref(__)('SEND_MESSAGE')}...`,
                      readonly: _unref(isMessageSendBlocked),
                      onKeydown: _withKeys(sendMessageOnEnter, ["enter"]),
                      onInput: onMessageInput,
                      style: _normalizeStyle({
                                paddingRight: `${(_unref(isEmojiUsed) ? 6 : 3)+_unref(textareaDesign).padding.leftRight}em !important`,
                                paddingLeft: `${_unref(textareaPaddingLeft)} !important`
                            }),
                      onPaste: onPaste,
                      "data-gramm": "false"
                    }, null, 44, _hoisted_9)
                  ]),
                  _: 1
                }, 512),
                _createVNode(ChatPopover, {
                  top: "",
                  visible: _unref(showEmoji),
                  "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(showEmoji) ? (showEmoji).value = $event : showEmoji = $event)),
                  style: {"padding-right":"0 !important","padding-left":"0 !important","right":"1em !important","left":"1em !important"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(ChatScrollContainer, {
                      enabled: _unref(showEmoji),
                      style: {"max-height":"300px !important","position":"relative !important"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(EmojiSelector, {
                          style: {"padding-right":"1em !important","padding-left":"1em !important"},
                          displayed: _unref(showEmoji),
                          onSelect: onEmojiSelect,
                          onSticker: onStickerSelect
                        }, null, 8, ["displayed"])
                      ]),
                      _: 1
                    }, 8, ["enabled"])
                  ]),
                  _: 1
                }, 8, ["visible"]),
                _createElementVNode("div", {
                  class: "icons typo blur-on-block",
                  style: _normalizeStyle({
                            color: `${_unref(textareaDesign).controlsColor} !important`,
                            marginRight: `${_unref(textareaDesign).padding.leftRight}em !important`
                        })
                }, [
                  (_unref(isEmojiUsed))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "icon",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_isRef(showEmoji) //@ts-ignore
 ? showEmoji.value = !_unref(showEmoji) : showEmoji = !_unref(showEmoji)))
                      }, [
                        _createVNode(SvgIcon, {
                          "icon-name": "smile",
                          "icon-style": "light"
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (!_unref(hideUploadButton) && (_unref(isUploadAvailable) || _unref(isAudioAvailable)))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_unref(isAudioAvailable))
                          ? (_openBlock(), _createBlock(_component_voice_message_recorder, {
                              key: 0,
                              class: "d-inline-block",
                              onInput: onVoiceMessage
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_11, [
                                  _createVNode(SvgIcon, {
                                    "icon-name": "microphone",
                                    "icon-style": "light"
                                  })
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_unref(isUploadAvailable))
                          ? (_openBlock(), _createBlock(ChatUpload, {
                              id: "chat",
                              ref_key: "upload",
                              ref: upload,
                              class: "d-inline-block",
                              key: "upload",
                              onNewFiles: attachFiles
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_12, [
                                  _createVNode(SvgIcon, {
                                    "icon-name": "paperclip",
                                    "icon-style": "light"
                                  })
                                ])
                              ]),
                              _: 1
                            }, 512))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(showSendButton))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: _normalizeClass({
                            'icon send-button': true,
                            disabled: !_unref(isReadyToSend)
                        }),
                        onClick: _withModifiers(sendMessage, ["prevent","stop"])
                      }, [
                        _createVNode(SvgIcon, {
                          key: "send",
                          "icon-name": "send-button",
                          style: _normalizeStyle({ color: `${_unref(sendButtonColor)} !important` }),
                          class: "link-color"
                        }, null, 8, ["style"])
                      ], 2))
                    : _createCommentVNode("", true)
                ], 4)
              ]))
            : (_unref(isButtonDisplayed))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "chat-footer-button",
                  style: _normalizeStyle({ color: `${_unref(sendButtonColor)} !important` })
                }, [
                  (_unref(isOfflineFormButtonDisplayed))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_unref(offlineButtonText)), 1)
                      ], 64))
                    : (_unref(isStartButtonDisplayed))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_unref(startButtonText)), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                ], 4))
              : _createCommentVNode("", true)
        ], 4)
      ], 2))
    : _createCommentVNode("", true)
}
}

})